<template>
  <div>
    <div class=" container">
      <el-table stripe v-loading="loading" class="tables" ref="multipleTable" :data="tableData" border
        tooltip-effect="dark" style="width: 100%">
        <el-table-column prop="contacts" label="联系人" width="100">
        </el-table-column>
        <el-table-column prop="tel" label="电话"  width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="enterpriseName" label="公司" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="source" label="来源" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="yourRequirements" label="需求" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="type" label="企业类型" width="100" >
          <template v-slot="{ row }">
            {{ typeFind(row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="creationTime" label="申请时间" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{backName(row.creationTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="applyStatus" label="状态" width="100" >
          <template v-slot="{ row }">
            {{ formFind(row.applyStatus) }}
          </template>
        </el-table-column>>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <span class="menu-button" @click="openEdit(scope.row)">修改状态</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-row flex-center" style="margin-top: 50px;  ">
        <el-button round @click="prev"  icon="el-icon-arrow-left">上一页</el-button>
        <div style="margin: 0px 10px; font-weight: bold;">{{ currentPage }}</div>   
        <el-button round  @click="next"  icon="el-icon-arrow-right">下一页</el-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <el-form :rules="rules" ref="form" style="width: 100%" :border="true" label-width="80px" :model="formLabel">
        <el-form-item label="申请状态" prop="applyStatus" required>
          <el-select v-model="formLabel.applyStatus" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeData">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { GetApplyExprienceList, SetApplyExprienceStatus } from '@/api/tables/tables';
import dayjs from 'dayjs'
export default {
  name: "registration",
  components: {
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      type: "add",
      typeOptions: [
        {
          value: 1,
          label: '服务商'
        }, {
          value: 2,
          label: '药企'
        },
      ],
      options: [{
        value: 0,
        label: '已报名'
      }, {
        value: 1,
        label: '联系中'
      }, {
        value: 2,
        label: '系统体验中'
      }, {
        value: 3,
        label: '合作成功'
      }, {
        value: 4,
        label: '放弃合作'
      }],
      formLabel: {
        applyStatus: null,
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        applyStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
    // console.log(dayjs().format('YYYY-MM-DD'))  
    // this.getList();
  },
  methods: {
    formFind(num) {
      // 通过id找到对应的元素的value
      const val = this.options.find(item => item.value == num)
      if (val) {
        return val.label
      } else {
        return '不能确定'
      }
    },
    typeFind(num) {
      const val = this.typeOptions.find(item => item.value == num)
      if (val) {
        return val.label
      } else {
        return ''
      }
    },
    backName(time) {
      return  dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getList() {
      var obj = {
        "pageIndex": this.currentPage,
        "pageSize": this.pageSize,
      }
      GetApplyExprienceList(obj)
        .then((res) => {
          if (res.data.success) {
            this.loading = false
            this.tableData = res.data.data.items
          }
        })
    },
    prev() {
      if (this.currentPage != 1) {
        this.currentPage--
        this.handleCurrentChange()
      } else {
        return
      }

    },
    next() {
      if(this.tableData.length<this.pageSize){
      return
      }
      this.currentPage++
      this.handleCurrentChange()
    },
    // 页数切换
    handleCurrentChange() {
      this.loading = true
      setTimeout(() => {
        this.getList()
      }, 400);
    },
    // 打开编辑
    openEdit(row) {
      this.type = "edit"
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.id = row.id
        this.formLabel.applyStatus = JSON.parse(JSON.stringify(row.applyStatus));;
      })
    },
    //编辑数据
    changeData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          SetApplyExprienceStatus(
            {
              id: this.id,
              applyStatus: this.formLabel.applyStatus
            }
          )
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "修改成功！",
                  type: 'success'
                });
                this.loading = true;
                setTimeout(() => {
                  this.getList();
                }, 1000);
              } else {
                this.$message.error('失败！');
              }
            })
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
  },

};
</script>
  
<style lang="scss" scoped>
.tables {
  margin-top: 30px;
}

.menu-button {
  color: #2970EC;
  cursor: pointer;

}
</style>
  